<template>
    <div class="forget">
        <div class="primary" />
        <el-form :model="form" :rules="rules" class="form" ref="form">
            <router-link style="position: absolute; top: 20px; left: 20px;" to="/login">
                <el-button circle icon="el-icon-back" type="primary" />
            </router-link>
            <h1 class="title">找回密码</h1>
            <el-form-item prop="mobile">
                <el-input
                    autocomplete="off"
                    maxlength="11"
                    placeholder="请输入手机号"
                    v-model="form.mobile"
                />
            </el-form-item>
            <el-form-item prop="verifyCode">
                <el-input
                    autocomplete="off"
                    class="input-code"
                    placeholder="请输入验证码"
                    v-model="form.verifyCode"
                />
                <el-button
                    @click="getCode"
                    class="btn-code"
                    type="primary"
                    v-if="time === DEFAULT_TIME"
                >获取验证码</el-button>
                <el-button disabled style="width: 120px;" v-else>重新获取 ({{ time }})</el-button>
            </el-form-item>
            <el-form-item prop="pass">
                <el-input
                    autocomplete="off"
                    placeholder="请输入新密码"
                    type="password"
                    v-model="form.pass"
                />
            </el-form-item>
            <el-form-item prop="checkPass">
                <el-input
                    autocomplete="off"
                    placeholder="确认新密码"
                    type="password"
                    v-model="form.checkPass"
                />
            </el-form-item>
            <el-button @click="handleSubmit" class="btn-submit" type="primary">确定</el-button>
        </el-form>
    </div>
</template>

<script>
import { api, post } from '../../service';
import { ROUTER_LOGIN } from '../../router.js';

let timer = null;
const DEFAULT_TIME = 60;

export default {
    data() {
        var checkPass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.form.pass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            DEFAULT_TIME,
            rules: {
                mobile: [
                    {
                        message: '请输入正确手机号',
                        required: true,
                        pattern: /^\d{11}$/,
                        trigger: 'change',
                    },
                ],
                verifyCode: [
                    {
                        message: '请输入验证码',
                        required: true,
                        trigger: 'change',
                    },
                ],
                pass: [
                    {
                        message: '请输入密码',
                        required: true,
                        trigger: 'change',
                    },
                ],
                checkPass: [{ validator: checkPass, trigger: 'change' }],
            },
            form: {
                mobile: '',
                verifyCode: '',
                pass: '',
                checkPass: '',
            },
            time: DEFAULT_TIME,
        };
    },
    methods: {
        async getCode() {
            if (!/^\d{11}$/.test(this.form.mobile)) {
                return this.$message.error('请输入正确的手机号！');
            }
            this.time -= 1;
            timer = setInterval(() => {
                if (this.time === 0) {
                    clearInterval(timer);
                    this.time = DEFAULT_TIME;
                } else {
                    this.time -= 1;
                }
            }, 1000);
            await post(api.user.getCode, { mobile: this.form.mobile });
            this.$message.success('获取验证码成功！');
        },
        handleSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    const params = {
                        mobile: this.form.mobile,
                        verifyCode: this.form.verifyCode,
                        password: this.form.pass,
                    };
                    await post(api.user.resetPwd, params);
                    this.$message.success('重置密码成功！');
                    this.$router.push(ROUTER_LOGIN);
                }
            });
        },
    },
    beforeDestroy() {
        clearInterval(timer);
    },
};
</script>

<style lang="less" scoped>
.forget {
    height: 100vh;
}
.primary {
    width: 100%;
    height: 50%;
    background-color: #2196f3;
    position: absolute;
    top: 0;
    left: 0;
}
.form {
    width: 460px;
    background-color: #ffffff;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2),
        0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    padding: 20px 50px 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.title {
    text-align: center;
    font-size: 42px;
    color: #2196f3;
    margin-bottom: 30px;
}
.input-code {
    width: calc(100% - 140px);
    margin-right: 20px;
}
.btn-code {
    width: 120px;
}
.btn-submit {
    width: 100%;
}
</style>
